import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SearchState {
  isSearching: boolean;
  searchTerm: string;
  isSocialFeed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FeedSearchService {
  private searchStateSubject = new BehaviorSubject<SearchState>({
    isSearching: false,
    searchTerm: '',
    isSocialFeed: false
  });

  public searchState$ = this.searchStateSubject.asObservable();

  constructor() { }

  setSearchState(state: Partial<SearchState>): void {
    const currentState = this.searchStateSubject.value;
    this.searchStateSubject.next({ ...currentState, ...state });
  }

  getSearchState(): SearchState {
    return this.searchStateSubject.value;
  }

  clearSearch(): void {
    this.setSearchState({
      isSearching: false,
      searchTerm: ''
    });
  }

  startSearch(term: string, isSocialFeed: boolean = false): void {
    this.setSearchState({
      isSearching: true,
      searchTerm: term,
      isSocialFeed
    });
  }
} 